import { Link } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PersonIcon from '@mui/icons-material/Person';
import Paper from '@mui/material/Paper';
import HistoryIcon from '@mui/icons-material/History';
import PaymentIcon from '@mui/icons-material/Payment';
import { useState } from 'react';

function ButtomBar() {
  const { pathname } = window.location;
  const [value, setValue] = useState(pathname);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="lg:hidden">
        <BottomNavigation
          sx={{ borderRadius: 5, position: 'fixed', bottom: 10, left: 10, right: 10, 
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              '& .MuiBottomNavigationAction-root': {
                borderRadius: 5,
                paddingY: 0.5,
                transition: 'all 0.3s ease',
              },
              '& .MuiBottomNavigationAction-root.Mui-selected': {
                backgroundColor: 'rgba(79, 168, 147, 0.1)',
              },
          }}
          value={value}
          onChange={handleChange}
          showLabels
          component={Paper}
          elevation={0}
        >
          <BottomNavigationAction
            label="จ่ายบิล"
            value="/show-invoice"
            icon={<PaymentIcon />}
            component={Link}
            to="/show-invoice"
          />
          <BottomNavigationAction
            label="ประวัติการชำระ"
            value="/payment-list-user"
            icon={<HistoryIcon />}
            component={Link}
            to="/payment-list-user"
          />
          {/* <BottomNavigationAction
            label="โปรไฟล์"
            value="/setting"
            icon={<PersonIcon />}
            component={Link}
            to="/setting"
          /> */}
        </BottomNavigation>
    </div>
  );
}

export default ButtomBar;